import React, { Suspense, lazy } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Segment, Sidebar } from 'semantic-ui-react';
import { route } from 'src/app/route';
import { HeaderBar } from 'src/components/header-bar';
import MenuBar from './menu-bar';
const LogManager = lazy(() => import('src/components/log/log-manager'));

export class LogPage extends React.PureComponent<RouteComponentProps<{}>> {
  public componentDidMount() {
    document.title = route.getPageTitle(this.props.location.pathname);
  }

  public render() {
    const title = route.getPageTitle(this.props.location.pathname);
    return (
      <Sidebar.Pushable as={Segment} className='x-page'>
        <MenuBar />

        <Sidebar.Pusher>
          <Segment basic={true}>
            <HeaderBar title={title} />
            <Suspense fallback={<div className='x-loading' />}>
              <LogManager />
            </Suspense>
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}
